import { ABR_VIEW, H5LIVE_VIEW, HISTORY_VIEW, HOME_VIEW, MOQ_VIEW, WEBRTC_VIEW, LIVE_CAPTIONS_VIEW } from './general';

export const SHOW_FOR = {
   ALL: 'ALL',
   ADMIN_ONLY: 'ADMIN_ONLY',
};

export const ViewsWithShownTimeInterval = {
   [HOME_VIEW]: SHOW_FOR.ALL,
   [H5LIVE_VIEW]: SHOW_FOR.ALL,
   [MOQ_VIEW]: SHOW_FOR.ALL,
   [ABR_VIEW]: SHOW_FOR.ADMIN_ONLY,
   [WEBRTC_VIEW]: SHOW_FOR.ALL,
   [HISTORY_VIEW]: SHOW_FOR.ALL,
   [LIVE_CAPTIONS_VIEW]: SHOW_FOR.ALL,
};
